import PageHeader from 'src/components/organisms/PageHeader';
import Footer from 'src/components/molecules/footer/Footer';
import ContentCardsContainer, { CardType, ContentCard } from 'src/components/organisms/ContentCard';
import { CustomDataGrid } from 'src/components/organisms/CustomDataGrid';
import { generateTablePageButtons } from 'src/utils/generateTablePageButtons';
import { useCustomersTable } from 'src/hooks/table/configs/useCustomersTable';

export const Customers = () => {
  const [columns, tableSettings] = useCustomersTable();

  return (
    <>
      <PageHeader
        {...{
          title: 'Customers',
          subTitle: 'View Customers information and details',
          components: [...generateTablePageButtons(tableSettings)],
        }}
      />

      <ContentCardsContainer>
        <ContentCard {...{ cardTypes: [CardType.noHeader], contentPadding: 0 }}>
          <CustomDataGrid columns={columns} tableSettings={tableSettings} />
        </ContentCard>
      </ContentCardsContainer>

      <Footer />
    </>
  );
};

export default Customers;
